import React from "react";
import "./ComboBoxItem.css";

export interface IComboBoxItemProps<T> {
  content: React.ReactNode,
  onHover?: () => void,
  onBlur?: () => void,
  onClick: () => (Promise<any> | any)
}

export default function ComboBoxItem<T>({ onHover, content, onBlur, onClick }: IComboBoxItemProps<T>) {

  if (!content) return null;

  return (
    <div
      className="combo-box-item p-2 w-100 text-start d-flex align-items-center justify-content-start"
      onMouseEnter={onHover}
      onMouseOver={onHover}
      onMouseLeave={onBlur}
      onClick={onClick}
    >
      <div className="w-100 h-100">
        {
          content
        }
      </div>
      <div className="combo-box-item-background" />
    </div>
  )
}